import { ShowHome } from '@propertypal/shared/src/types/show-homes';
import Button from '@propertypal/web-ui/src/buttons/Button';
import PropertyPrice from '@propertypal/web-ui/src/property/PropertyPrice';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import ShowHomesMoreDevelopments from './ShowHomesMoreDevelopments';
import { Container, MobileTable, MobileTableBox, SmallText, Table } from './ShowHomesTable.style';

interface Props {
  showHomes: ShowHome[];
  totalDevelopments: number;
  townName?: string;
}

const ShowHomesTable: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container>
      {!props.showHomes.length && (
        <>
          <SubHeading mb={30}>Sorry, there are no show homes open at the moment</SubHeading>

          <Text>Please check this page again later to see any updates.</Text>
        </>
      )}

      {!!props.showHomes.length && (
        <>
          <SubHeading mb={30}>All Show Homes{props.townName && ` in ${props.townName}`}</SubHeading>

          <Table>
            <thead>
              <tr>
                <th>Development Name</th>
                <th>Price</th>
                <th>Show Home Times</th>
                <th> </th>
              </tr>
            </thead>

            <tbody>
              {props.showHomes.map((showHome) => (
                <tr key={showHome.path}>
                  <td>
                    <p>{showHome.developmentName}</p>
                    {showHome.developer && <SmallText>Developed by {showHome.developer}</SmallText>}
                  </td>
                  <td>
                    <PropertyPrice as="span" primaryColor={theme.textDark} fontSize={16} price={showHome.price} />{' '}
                  </td>
                  <td>{showHome.times}</td>
                  <td>
                    <Link href={showHome.path}>
                      <Button containerStyle={{ minWidth: 220 }}>View Development</Button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <MobileTable>
            {props.showHomes.map((showHome) => (
              <MobileTableBox key={showHome.path}>
                <h3>{showHome.developmentName}</h3>
                {showHome.developer && <h6>Developed by {showHome.developer}</h6>}

                <PropertyPrice as="span" primaryColor={theme.textDark} fontSize={16} price={showHome.price} />
                <h5>{showHome.times}</h5>

                <Link href={showHome.path}>
                  <Button containerStyle={{ minWidth: 260 }}>View Development</Button>
                </Link>
              </MobileTableBox>
            ))}
          </MobileTable>
        </>
      )}

      <ShowHomesMoreDevelopments totalDevelopments={props.totalDevelopments} />
    </Container>
  );
};

export default ShowHomesTable;
